import React from "react";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import "./Cookie.css";

const Cookie = () => {
  const [cookies, setCookie] = useCookies(["cookieConsent"]);
  const giveCookieConsent = () => {
    setCookie("cookieConsent", true, { path: "/" });
  };

  return (
    <div className="cookie-consent">
      <div className="cookie-inner">
        <p>
          Notre site utilise exclusivement des cookies indispensables pour
          assurer son bon fonctionnement. Aucun cookie tiers n'est employé.{" "}
          <Link to="/confidentialité" className="cookie-link">
            Politique de confidentialité
          </Link>
        </p>
        <button className="cookie-btn" onClick={giveCookieConsent}>
          Accepter
        </button>
      </div>
    </div>
  );
};

export default Cookie;
